export default "__VITE_ASSET__24bcb0c8__"